import { apiRequest } from "./client";

// One row per claimed PairingCode. `id` is the device identity used
// throughout — events stamp it as `tvId`, parent commands target it by it,
// and unpair is keyed by it.
export type TvDevice = {
  id: string;
  name: string;
  claimedAt: string;
  online: boolean;
};

export const pairingApi = {
  status: (token: string) =>
    apiRequest<{ paired: boolean; online: boolean }>("/v1/pairing/status", {
      token,
    }),

  start: () =>
    apiRequest<{ code: string; expiresAt: string }>("/v1/pairing/start", {
      method: "POST",
    }),

  claim: (code: string, token: string) =>
    apiRequest<{ tvToken: string }>("/v1/pairing/claim", {
      method: "POST",
      body: { code },
      token,
    }),

  exchange: (code: string) =>
    apiRequest<{ accessToken: string; parentId: string; tvId?: string }>(
      "/v1/pairing/exchange",
      { method: "POST", body: { code } },
    ),

  // Remove the TV pairing from this parent account entirely.
  // Backend: DELETE /v1/pairing  (needs implementation — see backend note)
  unpair: (token: string) =>
    apiRequest<{ ok: boolean }>("/v1/pairing", {
      method: "DELETE",
      token,
    }),

  // Multi-TV: list every claimed device for this parent, with live online
  // state derived from the WebSocket gateway.
  devices: (token: string) =>
    apiRequest<TvDevice[]>("/v1/pairing/devices", { token }),

  // Multi-TV: unpair one specific device by its PairingCode.id. Other TVs
  // for the same parent are untouched. Backend emits `forced_unpair` to
  // every socket bound to that device.
  unpairDevice: (id: string, token: string) =>
    apiRequest<{ ok: boolean }>(`/v1/pairing/devices/${id}`, {
      method: "DELETE",
      token,
    }),
};
